import { HEADER_NAV_ITEM_LABELS } from './messages'
import { HEADER_NAV_ITEM } from './types'

export const headerNavItemData = {
  [HEADER_NAV_ITEM.HOME]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.HOME],
    activePathnames: ['/search-care'],
    activeScreenNames: ['Homebase'],
  },
  [HEADER_NAV_ITEM.CARE]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.CARE],
    activePathnames: ['/assignments', '/care/initial', '/progress', '/sessions'],
    activeScreenNames: ['Activities', 'CareInitial', 'Progress', 'Sessions'],
  },
  [HEADER_NAV_ITEM.SESSIONS]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.SESSIONS],
    activePathnames: ['/sessions'],
    activeScreenNames: ['Sessions'],
  },
  [HEADER_NAV_ITEM.ESSENTIALS]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.ESSENTIALS],
    activePathnames: ['/essentials', '/work-hub'],
    activeScreenNames: ['Essentials', 'Workhub'],
  },
  [HEADER_NAV_ITEM.BENEFITS]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.BENEFITS],
    activePathnames: ['/search-care/benefits'],
    activeScreenNames: ['Benefits'],
  },
  [HEADER_NAV_ITEM.FAVORITED_PROVIDERS]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.FAVORITED_PROVIDERS],
    activePathnames: ['/favorited-providers'],
    activeScreenNames: ['FavoritedProvidersScreen'],
  },
  [HEADER_NAV_ITEM.ACCOUNT]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.ACCOUNT],
    activePathnames: ['/profile'],
    activeScreenNames: ['Profile'],
  },
  [HEADER_NAV_ITEM.FAQS]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.FAQS],
    activePathnames: ['/faq'],
  },
  [HEADER_NAV_ITEM.CARE_NAVIGATOR]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.CARE_NAVIGATOR],
  },
  [HEADER_NAV_ITEM.REFERRAL]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.REFERRAL],
  },
  [HEADER_NAV_ITEM.LOG_OUT]: {
    label: HEADER_NAV_ITEM_LABELS[HEADER_NAV_ITEM.LOG_OUT],
  },
}

export const NAV_HEADER_HEIGHT = 56
export const FLOATING_TAB_BAR_HEIGHT = 64
